const css = `._3rB84q__sm{height:24px;width:24px}._3rB84q__md{height:32px;width:32px}._3rB84q__lg{height:40px;width:40px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"lg":"_3rB84q__lg","sm":"_3rB84q__sm","md":"_3rB84q__md"};
